import React from 'react'
import { Select } from 'antd'
import { t } from 'i18next'
import { notificationError, notificationSuccess } from '../../Common/Common'
import { post } from '../../Common/api'

const defaultOnChange = (value, event, updateEventData) => {
  post(`admin/events/${event.id}/in_charge`, { in_charge: value }, (json) => {
    updateEventData({ ...json.event, comments: json.comments })
    notificationSuccess('update')
  }, () => {
    notificationError('update')
  })
}

export default function EventInChargeSelect ({ event, updateEventData, inCharge, style = { minWidth: '100%' }, onChange = defaultOnChange }) {
  const options = inCharge ? Object.keys(inCharge.name).map((k) => ({ value: k, label: inCharge.name[k] })) : []

  return (
    <Select value={event?.in_charge} options={options} onChange={(v) => onChange(v, event, updateEventData)} style={style}
      placeholder={t('Admin.EventList.table.nobodyInCharge')} defaultValue={event ? '' : 'vig_1'}/>
  )
}
